import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import { Header } from 'components/Header'
import { Spinner } from 'components/Spinner'

import {
  getCustomerInfoAction,
  setAuthTokenAction,
} from 'root-redux/actions/user'
import { selectAppName } from 'root-redux/selects/common'
import { TAppDispatch } from 'root-redux/store/store'

import { useAuthObserver } from 'hooks/useAuthObserver'
import { useGetRedirectResult } from 'hooks/useGetRedirectResult'
import { useInitFirebase } from 'hooks/useInitFirebase'

import { EmailLogin } from 'modules/unsubscribeLogin/components/EmailLogin'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'
import { AppName } from 'root-constants'

import { StyledUnsubscribeLogin as S } from './UnsubscribeLogin.styles'

export const UnsubscribeLogin: React.FC = () => {
  const { search } = useLocation()
  const dispatch: TAppDispatch = useDispatch()
  const appName = useSelector(selectAppName)

  const [isFirebaseDataLoading, setIsFirebaseDataLoading] = useState(false)

  const authStateChangeHandler = useCallback(
    (token: string) => {
      dispatch(setAuthTokenAction(token))
      dispatch(getCustomerInfoAction({ hasEvent: true }))

      goTo(
        search
          ? `${PageId.SUBSCRIPTION_DETAILS}${search}&token=${token}`
          : `${PageId.SUBSCRIPTION_DETAILS}?token=${token}`,
      )
    },
    [dispatch, search],
  )

  useInitFirebase()
  useGetRedirectResult(authStateChangeHandler, setIsFirebaseDataLoading)
  useAuthObserver(authStateChangeHandler)

  if (!appName) return <Spinner />

  if (appName === AppName.SPILIO) {
    return <Navigate to={`/${PageId.NOT_FOUND}`} />
  }

  return (
    <S.Wrapper>
      {isFirebaseDataLoading && <Spinner />}
      <Header />
      <EmailLogin />
    </S.Wrapper>
  )
}
